var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('top',{staticClass:"home-top"}),_c('div',{staticClass:"home-content"},[_c('left',{staticClass:"left"}),_c('center',{staticClass:"center"}),_c('right',{staticClass:"right"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }